<template>
        <v-container
                fluid
        >
            <v-row
                    align="center"
                    justify="center"
            >
                <v-col
                        cols="12"
                        sm="6"
                >
                    <v-card
                            width="400px"
                            class="mx-auto elevation-7"
                    >
                        <v-toolbar
                                class="mb-5"
                                dark
                                flat
                                color="primary"
                        >
                            <v-toolbar-title>
                                {{ $t('mensaje_login')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-img
                                class="ml-4 mr-4"
                                :src="language === 'es' ? require('../assets/residencial_mx.png') : require('../assets/residencial_eu.png')"
                                height="250px"
                                contain
                        ></v-img>
                        <v-card-text>
<!--                            <ValidationObserver v-slot="{ handleSubmit }">-->
                                <v-form
                                        class="mb-4"
                                        @submit.prevent="login()"
                                >
                                    <v-text-field
                                            autofocus
                                            v-model="correo"
                                            name="correo"
                                            prepend-icon="mdi-account"
                                            label="E-Mail"
                                            :error-messages="errores.email"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                            v-model="password"
                                            name="password"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password')"
                                            :type="show ? 'text' : 'password'"
                                            :error-messages="errores.password">
                                    </v-text-field>
                                    <v-alert
                                            :value=alerta
                                            type="warning"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.non_field_errors}}
                                    </v-alert>

                                    <v-card-actions>
                                        <v-flex>
                                            <span>{{$t('mensaje_olvidar_contrasena')}}</span>
                                            <span>
                                                {{$t('mensaje_link_restablecer1')}}
                                                <router-link :to="{ name: 'reset_password'}">
                                                    {{$t('mensaje_link_restablecer2')}}
                                                </router-link>
                                                {{$t('mensaje_link_restablecer3')}}
                                            </span>
                                        </v-flex>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                    <v-btn
                                            :loading="loading"
                                            color="primary"
                                            type="submit"
                                    >
                                        {{$t('ingresar')}}
                                    </v-btn>
                                    <br>
                                    <br>
                                    <v-btn
                                            to="/signup_apartment"
                                            block
                                            color="primary"
                                    >{{$t('sign_up_house')}}
                                        <v-icon right dark>mdi-home-edit</v-icon>
                                    </v-btn>
                                </v-form>
<!--                            </ValidationObserver>-->
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { AUTH_REQUEST } from '../store/actions/auth'
import Vue from 'vue'
import { ValidationProvider } from 'vee-validate'

Vue.component('ValidationProvider', ValidationProvider)

export default {
  name: 'Login',
  data: () => ({
    errores: [],
    show: false,
    correo: '',
    password: '',
    alerta: false,
    loading: false
  }),
  computed: {
    ...mapState(['language'])
  },
  methods: {
    login () {
      this.loading = true
      this.$store.dispatch(AUTH_REQUEST, { email: this.correo, password: this.password, language: this.language })
        .then(ok => {
          this.loading = false
          if (localStorage.getItem('pathValidationUser') !== null) {
            this.$router.push({ path: localStorage.getItem('pathValidationUser') })
            localStorage.removeItem('pathValidationUser')
          } else {
            this.$router.push({ name: 'home' })
          }
        })
        .catch(error => {
          // if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          // console.log(error)
          this.errores = error.response.data
          this.loading = false
          if (error.response.data['non_field_errors'] != null) {
            this.alerta = true
            setTimeout(this.clear, 2000)
            this.loading = false
          }
          // }
        })
    },
    clear () {
      this.alerta = false
      this.errores = []
      // this.$validator.reset()
    }
  }
}
</script>
